import Reflux from "reflux";
export const StorageActions = {
  get: Reflux.createAction(),
  add: Reflux.createAction(),
  remove: Reflux.createAction()
};
